function runinlayPopup(){if(window.location.pathname.includes("/products/")||!window.location.pathname.includes("/blogs")){console.log("On a product page \u2192 script stopped.");return}if(["https://newzealandhoneyco.com/pages/manuka-honey-for-gut-health-h-pylori-gerd-reflux-gastritis-colitis","https://newzealandhoneyco.com/pages/manuka-honey-for-immunity","https://newzealandhoneyco.com/pages/manuka-honey-for-gut-health-h-pylori-gerd-reflux-gastritis-colitis#pylori","https://newzealandhoneyco.com/pages/manuka-honey-for-immunity#cold-flu","https://newzealandhoneyco.com/pages/manuka-honey-for-immunity#sore-throats"].includes(window.location.href))return;const span=document.querySelector(".shg-rich-text.shg-theme-text-content span");if((span?span.textContent.trim():"").includes("CUSTOMER STORY")){console.log("Customer Story page detected \u2192 script stopped.");return}console.log("\u{1F514} NZ Honey script running on",window.location.pathname);const style=document.createElement("style");style.textContent=`
        body .c-product__rating__star--custom svg {
         background-color: #333 !important;
       }

       body .nzhc_prodDetail .nzhc_stickyImg {
            background-color: #fff !important;
        }

        body .nzhc_prodDetail .nzhc_stickyImg img{
          background-color: #fff !important;
        }
   
       body .c-product__rating__stars .c-product__rating__star--custom {
        background-color: #333 !important;
    }

      body .nzhc_review .c-product__rating__infos {
        background-color: #333 !important;
      }   

        .nzhc_stickyCTA,
            .nzhc_stickyWrapper {
            background-color: #333 !important;
        }

        .nzhc_stickyCTA a {
            background-color: #d6206c !important;
        }

        .c-product__rating__infos {
            background-color: #333 !important;
        }

        .nzhc_stickyImg img {
            background-color: #fff !important;
        }

        .nzhc_prodDetail,
        .nzhc_stickyDetail h6,
        .nzhc_review {
        background-color: #333 !important;
        }

        html.nzHoney_blackout,
        html.nzHoney_blackout *,
        body.nzHoney_blackout,
        body.nzHoney_blackout * {
        background-color: #b6b2b2a6 !important;
        }

        .nzHoney_overlaysPopup + .klaviyo-form {
        display: none;
        }

        .nzHoney_overlaysPopup {
        position: relative;
        width: 100%;
        overflow: hidden;
        }

        .nzHoney_overlaysPopup img {
        width: 100%;
        height: 100%;
        }

        .nzHoney_overlaysPopup .mobileImage {
        display: none;
        }

        .nzHoney_overlaysPopup .desktopImage {
        display: block;
        }


        body .nzhc_stickyWrapper{
            background-color: #333 !important;
        }

        body  .nzhc_stickyCTA{
            background-color: #333 !important;
        }

        body .progress-bar-container{
            background-color: #f3f3f3 !important;
        }

        body .nzhc_prodDetail{
            background-color: #333 !important;
        }

        body .nzhc_stickyCTA a {
            background-color: #d6206c !important;
        }

        body .nzhc_review{
            background-color: #333 !important;
        }

        body .nzhc_stickyDetail h6 {
            background: #333 !important;
        }

        body .nzhc_stickyDetail {
            background: #333 !important;
        }

        body .product__rating__infos{
            background-color: #333 !important;
        }


        @media only screen and (max-width: 767px) {
        .nzHoney_overlaysPopup .mobileImage {
            display: block;
        }
        .nzHoney_overlaysPopup .desktopImage {
            display: none;
        }

 
        .article-template__content {
            width: 100%;
            margin: 0 auto;
        }

        
        }

   `,document.head.appendChild(style);const waitForElements=(selector,timeout=1e4)=>new Promise((resolve,reject)=>{let elapsed=0;const iv=setInterval(()=>{const found=Array.from(document.querySelectorAll(selector));found.length?(clearInterval(iv),resolve(found)):elapsed>=timeout&&(clearInterval(iv),reject(new Error(`Timeout waiting for "${selector}"`))),elapsed+=50},50)}),delay=ms=>new Promise(r=>setTimeout(r,ms));(async()=>{try{console.log("\u23F3 NZ Honey: waiting for Shogun containers\u2026");const targetElems=await waitForElements(".shogun-image-container:not([data-animations]), .shg-product-image-wrapper",1e4);console.log("\u2705 NZ Honey: found",targetElems.length,"Shogun containers"),targetElems.forEach(el=>{if(el.closest(".stacked"))return;const box=el.closest(".shg-box");box&&(box.classList.add("hideExisting_Honey"),console.log("\u21B3 NZ Honey: hiding box",box))}),console.log("\u23F3 NZ Honey: waiting 2.5s for Klaviyo forms\u2026"),await delay(2500);const forms=document.querySelectorAll(".klaviyo-form");if(console.log("\u{1F50D} NZ Honey: Klaviyo forms found:",forms.length),!forms.length){console.warn("\u26A0 NZ Honey: no Klaviyo forms \u2192 aborting overlay");return}const firstForm=forms[0];console.log("\u{1F3AF} NZ Honey: targeting first Klaviyo form",firstForm),firstForm.insertAdjacentHTML("beforeBegin",`<div class="nzHoney_overlaysPopup w3_bg">
                  <a href="/products/manuka-honey-umf-24-mgo-1122">
                    <img
                      class="mobileImage"
                      src="https://cdn.shopify.com/s/files/1/0071/9755/6794/files/nz-honey-manuka_1.png"
                    >
                    <img
                      class="desktopImage"
                      src="https://cdn.shopify.com/s/files/1/0071/9755/6794/files/desktop-banner_1.png"
                    >
                  </a>
                </div>`),console.log("\u{1F44D} NZ Honey: overlay inserted");const popupDiv=document.querySelector(".nzHoney_overlaysPopup"),cContainer=document.body;if(popupDiv&&cContainer){popupDiv.style.transition="transform 0.5s ease, box-shadow 0.5s ease";const bgEls=document.querySelectorAll('.shg-box[data-bgset], div[style*="background-image"]');window.addEventListener("scroll",()=>{const rect=popupDiv.getBoundingClientRect(),topThresh=window.innerHeight*.8,botThresh=window.innerHeight*.3;rect.top<=topThresh&&rect.bottom>=botThresh?(console.log("\u{1F526} NZ Honey: popup in view \u2192 dim+scale"),document.body.classList.add("nzHoney_blackout"),popupDiv.style.transform="scale(1.01)",bgEls.forEach(el=>{el.style.setProperty("background-size","contain","important"),el.style.setProperty("background-repeat","no-repeat","important")})):(console.log("\u{1F505} NZ Honey: popup out of view \u2192 reset"),popupDiv.style.transform="scale(1)",popupDiv.style.boxShadow="",document.body.classList.remove("nzHoney_blackout"),bgEls.forEach(el=>{el.style.setProperty("background-size","cover","important"),el.style.setProperty("background-repeat","no-repeat","important")}))})}else console.error("\u274C NZ Honey: popupDiv or container missing",popupDiv,cContainer)}catch(err){console.error("\u274C NZ Honey: error in popup logic:",err)}})()}runinlayPopup();
//# sourceMappingURL=/s/files/1/0071/9755/6794/t/179/assets/nz-honey.js.map?v=1759971114
